/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MarketplaceListingAlert } from '../model';
// @ts-ignore
import { MarketplaceListingAlertUser } from '../model';
// @ts-ignore
import { MarketplaceListingAlerts } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicMarketplaceAlertsApi - axios parameter creator
 * @export
 */
export const PublicMarketplaceAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/marketplace/listing/alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUser} marketplaceListingAlertUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertUpdate: async (listingAlertId: string, marketplaceListingAlertUser: MarketplaceListingAlertUser, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingAlertId' is not null or undefined
            assertParamExists('marketplaceListingAlertUpdate', 'listingAlertId', listingAlertId)
            // verify required parameter 'marketplaceListingAlertUser' is not null or undefined
            assertParamExists('marketplaceListingAlertUpdate', 'marketplaceListingAlertUser', marketplaceListingAlertUser)
            const localVarPath = `/v2/marketplace/listing/alert/{listing_alert_id}`
                .replace(`{${"listing_alert_id"}}`, encodeURIComponent(String(listingAlertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketplaceListingAlertUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicMarketplaceAlertsApi - functional programming interface
 * @export
 */
export const PublicMarketplaceAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicMarketplaceAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingAlertList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketplaceListingAlerts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingAlertList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUser} marketplaceListingAlertUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingAlertUpdate(listingAlertId: string, marketplaceListingAlertUser: MarketplaceListingAlertUser, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketplaceListingAlert>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingAlertUpdate(listingAlertId, marketplaceListingAlertUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicMarketplaceAlertsApi - factory interface
 * @export
 */
export const PublicMarketplaceAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicMarketplaceAlertsApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertList(options?: any): AxiosPromise<MarketplaceListingAlerts> {
            return localVarFp.marketplaceListingAlertList(options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUser} marketplaceListingAlertUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertUpdate(listingAlertId: string, marketplaceListingAlertUser: MarketplaceListingAlertUser, options?: any): AxiosPromise<MarketplaceListingAlert> {
            return localVarFp.marketplaceListingAlertUpdate(listingAlertId, marketplaceListingAlertUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for marketplaceListingAlertUpdate operation in PublicMarketplaceAlertsApi.
 * @export
 * @interface PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest
 */
export interface PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertUpdate
     */
    readonly listingAlertId: string

    /**
     * 
     * @type {MarketplaceListingAlertUser}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertUpdate
     */
    readonly marketplaceListingAlertUser: MarketplaceListingAlertUser
}

/**
 * PublicMarketplaceAlertsApi - object-oriented interface
 * @export
 * @class PublicMarketplaceAlertsApi
 * @extends {BaseAPI}
 */
export class PublicMarketplaceAlertsApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceAlertsApi
     */
    public marketplaceListingAlertList(options?: any) {
        return PublicMarketplaceAlertsApiFp(this.configuration).marketplaceListingAlertList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Create or Update a User Alert
     * @param {PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceAlertsApi
     */
    public marketplaceListingAlertUpdate(requestParameters: PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest, options?: any) {
        return PublicMarketplaceAlertsApiFp(this.configuration).marketplaceListingAlertUpdate(requestParameters.listingAlertId, requestParameters.marketplaceListingAlertUser, options).then((request) => request(this.axios, this.basePath));
    }
}
